import React, { FC } from 'react';

import { IIconType } from './types';

export const IconChargeActive: FC<IIconType> = ({ size = 16 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 15 16" fill="none">
            <circle cx="7.5" cy="8" r="5.5" fill="#00FF45" />
            <circle cx="7.5" cy="8" r="6.5" stroke="#00FF80" strokeOpacity="0.6" strokeWidth="2" />
        </svg>
    );
};
